module.exports = __webpack_public_path__ + "static/img/user_admin.b8cf311.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user_admin.png
// module id = PE8T
// module chunks = 1